import React, { memo, useCallback } from 'react';
import PropTypes from 'prop-types';

import Select from 'containers/components/Fields/Select';

const normalizeSelectValue = (value, lowercase = false) => {
    if (value === null || value === undefined || value === '') return null;
    const normalized = String(value);
    return lowercase ? normalized.toLowerCase() : normalized;
};

const ProfileSelectField = memo(
    ({ label, mandatory, readOnly, error, value, options, onChange, lowercaseValue = false }) => {
        const handleChange = useCallback(
            (newValue) => {
                // Legacy select cleared with '' rather than undefined
                onChange && onChange(newValue ?? '');
            },
            [onChange],
        );

        return (
            <Select
                className="profile-settings-select-field"
                error={error}
                label={label}
                labelMode="horizontal"
                mandatory={mandatory}
                options={options}
                readOnly={readOnly}
                usePlainValue
                value={normalizeSelectValue(value, lowercaseValue)}
                onChange={handleChange}
            />
        );
    },
);

ProfileSelectField.displayName = 'ProfileSelectField';

ProfileSelectField.propTypes = {
    error: PropTypes.any,
    label: PropTypes.oneOfType([PropTypes.object, PropTypes.string]),
    lowercaseValue: PropTypes.bool,
    mandatory: PropTypes.bool,
    onChange: PropTypes.func,
    options: PropTypes.array,
    readOnly: PropTypes.bool,
    value: PropTypes.any,
};

export default ProfileSelectField;
